// src/store/idApi.ts
import { createApi } from '@reduxjs/toolkit/query/react'
import { idBaseQuery } from '@/api/idClient'

export const idApi = createApi({
  reducerPath: 'idApi',
  baseQuery: idBaseQuery,
  endpoints: () => ({}),
})
